<template>
  <div>
    <div v-if="latestStatus && latestStatus.type">
      <template v-if="latestStatus.type === 'auction'">
          <span class="mr-1 d-flex align-items-center">
            <template v-if="!enableContinuousAuction && $hasPermission('change_auction')">
              <router-link :to="{name: 'sales.view', params: {id: latestStatus.auction_uuid}}">
              {{ latestStatus.sale_no }}</router-link>
            </template>
            <template v-else>
              <span>
                <router-link v-if="$hasPermission('view_inventoryitem')"
                             :to="{ name: 'reservations.view', params: { id: latestStatus.inventory_item_reservation_uuid }}">
                  {{ latestStatus.sale_no }}
                </router-link>
                <span v-else>
                  {{ latestStatus.sale_no }}
                </span>
              </span>
            </template>
            <span class="mr-1 ml-1">-</span>
            <span v-as-status="latestStatus.status">
              {{ latestStatus.status | toUpperCaseFirst }} ({{ latestStatus.quantity }})
            </span>
            <span class="mr-1 ml-1">-</span>
            <span v-as-status="latestStatus.invoice_status">
              {{ latestStatus.invoice_status ? latestStatus.invoice_status : 'N/A' | toUpperCaseFirst }}
            </span>
          </span>
      </template>
      <template v-else>
        <span class="mr-1 d-flex align-items-center">
          <span>{{ latestStatus.invoice_number }}</span>
          <span class="mr-1 ml-1">-</span>
          <span v-as-status="latestStatus.invoice_status">
            {{ latestStatus.invoice_status | toUpperCaseFirst }} ({{ latestStatus.quantity }})
          </span>
        </span>
      </template>
      <div v-if="inventory[statusKey].length > 1">
        <span class="hover-cursor hover-underline"
              @click="onShowMoreClick"> {{ $t("+{n} more", {n: inventory[statusKey].length - 1}) }} </span>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import {SOURCE_INVENTORY_STATUS} from "@/modules/constants";

  const {mapState: globalMapState} = createNamespacedHelpers('global');
  const {mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryStatus",
    components: {},
    props: {
      inventory: {
        type: Object,
        required: true
      },
      statusKey: {
        type: String,
        default: 'statuses'
      }
    },
    computed: {
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      latestStatus() {
        return this.inventory[this.statusKey] && this.inventory[this.statusKey].length > 0 ? this.inventory[this.statusKey][0] : {}
      },
    },
    methods: {
      ...mapActions(['showInventoryStatusesModal']),
      onShowMoreClick() {
        this.showInventoryStatusesModal({
          inventory: this.inventory,
          source: SOURCE_INVENTORY_STATUS,
          statusKey: this.statusKey
        })
      }
    }
  }
</script>

<style scoped>

</style>
